import { createContext, useContext } from "react"
import { AutoFeederPond } from "../../database"

const AutoFeederPondContext = createContext<{
  autoFeederPond: AutoFeederPond|null,
  setAutoFeederPond: (autoFeederPond?: AutoFeederPond) => void
}>({
  autoFeederPond: null,
  setAutoFeederPond: () => undefined
})

export const AutoFeederPondProvider = AutoFeederPondContext.Provider
export const useAutoFeederPond = () => useContext(AutoFeederPondContext)
